import { Client } from "@smash-sdk/core";
import { HttpRequest, SDKError, config } from "@smash-sdk/core";
import { errors } from "./errors";
export * from "./errors";
export * from "./types/ComputeVat/ComputeVat";
export * from "./types/ListCountries/ListCountries";
export * from "./types/VerifyVatNumber/VerifyVatNumber";
const endpoints = {
    "ca-central-1": "https://vat.ca-central-1.fromsmash.co",
    "eu-central-1": "https://vat.eu-central-1.fromsmash.co",
    "eu-west-1": "https://vat.eu-west-1.fromsmash.co",
    "eu-west-2": "https://vat.eu-west-2.fromsmash.co",
    "eu-west-3": "https://vat.eu-west-3.fromsmash.co",
    "us-east-1": "https://vat.us-east-1.fromsmash.co",
    "us-east-2": "https://vat.us-east-2.fromsmash.co",
    "us-west-1": "https://vat.us-west-1.fromsmash.co",
    "us-west-2": "https://vat.us-west-2.fromsmash.co",
};
config.setHosts("vat", endpoints, false);
export class Vat extends Client {
    constructor(params = {}) {
        super({ service: "vat", ...params, type: "regional", userAgent: "@smash-sdk/vat@1.0.0-alpha.5" });
        this.errors = errors;
    }
    computeVat(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/vat/compute",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        vatNumber: params["vatNumber"],
                        priceExclTax: params["priceExclTax"],
                        priceInclTax: params["priceInclTax"],
                        exchangeRate: params["exchangeRate"],
                        countryCode: params["countryCode"],
                        bypassVatCheck: params["bypassVatCheck"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ComputeVatError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    listCountries() {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/countries",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListCountriesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
    verifyVatNumber(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/vatNumber/verify",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "10-2019",
                    },
                    bodyParameters: {
                        vatNumber: params["vatNumber"],
                        countryCode: params["countryCode"],
                        warmupDate: params["warmupDate"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new HttpRequest(requestParams);
                const response = await this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.VerifyVatNumberError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new SDKError(error));
                    }
                }
                else {
                    reject(new SDKError(error));
                }
            }
        });
    }
}
Vat.errors = errors;
